import CommonEdit from "@/components/common/Edit";
import { singleProp } from "@/interface/dataInterface";
import { FC, useEffect, useState } from "react";
import RefuelingForm from "../forms/RefuelingForm";
import axiosInstance from "@/utils/axiosInstance";
import { mergeDateAndTime, seperateDateAndTime } from "@/utils/formChange";

const RefuelingEdit: FC<singleProp> = ({ prop }) => {
  const [formProp, setFormProp] = useState({
    date: new Date(),
    time: "",
    vehicle_id: "",
    odometer: 0,
    type: "primary",
    notes: "",
  });
  const [otherData, setOtherData] = useState({
    price_primary: "",
    liters_primary: "",
    price_secondary: "",
    liters_secondary: "",
  });
  const [selectedVehicleOptions, setSelectedVehicleOptions] = useState<any>({
    two_tanks: false,
    fuel_id: 0,
  });

  useEffect(() => {
    const unsub = async () => {
      if (formProp.vehicle_id) {
        const response = await axiosInstance.get(
          `/vehicles/${formProp.vehicle_id}`,
        );
        setSelectedVehicleOptions({
          two_tanks: response.data.two_tanks,
          fuel_id: response.data.vehicle_tanks[0]?.fuel_id || 0,
        });
      }
    };
    unsub();
  }, [formProp.vehicle_id]);

  useEffect(() => {
    if (!prop) return;
    
    const unsub = async () => {
        const {data} = await axiosInstance.get(`/refueling/${prop}`)
        const {notes, odometer, refueling_tanks, date, vehicle_id} = data
        const {unit_value: liters_primary, total_cost: price_primary} = refueling_tanks[0] || {}
        const {unit_value: liters_secondary, total_cost: price_secondary} = refueling_tanks[1] || {}

        setFormProp({
            date: new Date(seperateDateAndTime(date).datePart),
            time: seperateDateAndTime(date).timePart,
            odometer,
            notes,
            vehicle_id,
            type: "primary"
        })

        setOtherData({
            liters_primary: liters_primary || "",
            price_primary: price_primary || "",
            liters_secondary: liters_secondary || "",
            price_secondary: price_secondary || ""
        })
    }

    unsub()
  }, [prop])

  return (
    <CommonEdit
      title="Edit"
      id={prop}
      resource="refueling"
      data={{
        data: {
          odometer: formProp.odometer,
          notes: formProp.notes,
          date: mergeDateAndTime(formProp.date, formProp.time),
          vehicle_id: +formProp.vehicle_id,
          two_tanks: selectedVehicleOptions?.two_tanks || false,
          missed_previous_refueling: false,
        },
        tanks: [
          formProp.type !== "primary" && {
            fuel_id: selectedVehicleOptions?.fuel_id || 0,
            unit_value: +otherData.liters_secondary,
            price: +otherData.price_secondary / +otherData.liters_secondary,
            total_cost: +otherData.price_secondary,
            are_you_filling_tank: false,
            type: "SECONDARY",
          },
          formProp.type !== "secondary" && {
            fuel_id: selectedVehicleOptions?.fuel_id || 0,
            unit_value: +otherData.liters_primary,
            price: +otherData.price_primary / +otherData.liters_primary,
            total_cost: +otherData.price_primary,
            are_you_filling_tank: false,
            type: "PRIMARY",
          },
        ].filter(Boolean),
      }}
    >
      <RefuelingForm mode="edit" formProp={formProp} setFormProp={setFormProp} otherData={otherData} setOtherData={setOtherData}/>
    </CommonEdit>
  );
};

export default RefuelingEdit;
